import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=6a9e9ec4"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=6a9e9ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports